module.exports = __webpack_public_path__ + "static/img/1.35e979e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/3/sp/1.png
// module id = XaKG
// module chunks = 0